const API_URL = 'https://interlake-xc-backend-tzxxrf7jra-uc.a.run.app';
// const API_URL = 'http://localhost:3001';

export function callAPI(route: string) {
  return fetch(`${API_URL}/${route}`).then((response) => response.json());
}